/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

//custom libraries
import { Button, RadioButtonGroup } from "../components";
import { EMPTY_STRING } from "../constants/common";
import { useStoreSelection } from "../hooks/use-store-selection";
import { TextField, CircularProgress } from "@material-ui/core";
//Material UI
import {
  FormControlLabel,
  FormControl,
  Radio,
  Typography,
  Grid,
  Paper,
} from "@material-ui/core";

const StoreSelector = styled(({ ...props }) => <Paper {...props} />)`
  ${({ theme }) => ` 
    border: 1px solid ${theme.palette.text.disabled};
    border-radius: 6px;
    padding: ${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px;

    ${theme.breakpoints.up("md")} {
      padding: ${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(
    2
  )}px;
    }

    .MuiIconButton-root {
      padding: ${theme.spacing(0.5)}px ${theme.spacing(1)}px;
    }
  `}
`;

export default function StoreSelection() {
  const {
    selectStore,
    options,
    selectedStore,
    buildStoreOptions,
    textFieldDisabled,
  } = useStoreSelection();
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    selectStore(event.target.value);
  };

  // Toggle the filter text field through onclick event
  const [showFilter, setShowFilter] = React.useState(false);
  const [selectStoredHeader, setSelectStoredHeader] = React.useState<String>(
    t("StoreSelection.SelectAStore")
  );
  const enableFilter = () => {
    setSelectStoredHeader(t("StoreSelection.SelectStoreToManage"));
    setShowFilter(true);
  };

  const disableFilter = () => {
    setSelectStoredHeader(t("StoreSelection.SelectStoreToManage"));
    setShowFilter(false);
    buildStoreOptions();
  };

  const filterStores = (event: any) => {
    const filter = event.target.value.toLowerCase();
    buildStoreOptions(filter);
  };

  React.useEffect(() => {}, [options]);

  return (
    <StoreSelector>
      <Grid item container direction="column" spacing={2} justify="flex-start">
        <Grid item>
          <Typography variant="h2">{selectStoredHeader}</Typography>
        </Grid>
        <Grid item xs={false}>
          {showFilter ? (
            <>
              <TextField
                fullWidth
                disabled={textFieldDisabled}
                onChange={filterStores}
                label={t("StoreSelection.FilterStoreSelection")}
                variant="outlined"
                className="bottom-margin-1"
              />
              <Button
                disableRipple
                text="Button"
                variant="text"
                onClick={disableFilter}>
                {t("StoreSelection.HideStoreSelection")}
              </Button>
            </>
          ) : (
            <Button
              disableRipple
              text="Button"
              variant="text"
              onClick={enableFilter}>
              {t("StoreSelection.FilterStoreSelection")}
            </Button>
          )}
        </Grid>
        {options.length >= 1 ? (
          <Grid item>
            <FormControl component="fieldset">
              <RadioButtonGroup
                onChange={handleChange}
                aria-label="store-name"
                name="store-name"
                value={selectedStore?.storeId || EMPTY_STRING}>
                {options.map((o) => (
                  <FormControlLabel
                    key={o.name}
                    value={o.value}
                    control={<Radio />}
                    label={o.name}
                  />
                ))}
              </RadioButtonGroup>
            </FormControl>
          </Grid>
        ) : (
          <CircularProgress />
        )}
      </Grid>
    </StoreSelector>
  );
}
